import React from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import TextEmphasisBloc from "../../../../components/WMS/TextEmphasisBloc";
import WMSCarrierIcon from "../../../../components/WMS/WMSCarrierIcon";
import {ReactComponent as BagIcon} from "assets/img/wms/bag.svg"
import CustomButton from "../../../../components/CustomButton";
import {Grid} from "@mui/material";
import {blueColor, greyishBlue500} from "../../../../assets/jss/main";

ReturnShipmentModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    selectedShipment: PropTypes.object.isRequired,
    handleBeginValidation: PropTypes.func.isRequired
};
function ReturnShipmentModal({open, handleClose, selectedShipment, handleBeginValidation}) {
    return (
        <Popup
            open={open}
            onClose={handleClose}
            icon={<BagIcon />}
            title={<FormattedMessage id={"wms.receptionList.returnModal.title"} values={{shipmentNumber: selectedShipment.externalDeliveryNumber}}/>}
            subtitle={<FormattedMessage id={"wms.receptionList.returnModal.subtitle"}/>}
            isMobile
        >
            <Grid container direction={'column'} gap={"8px"} justifyContent={"space-between"} alignItems={"center"}>
                    <Grid container sx={{width: "fit-content", color: greyishBlue500}}>
                        <div><FormattedMessage id={"wms.receptionList.returnModal.shipmentNumber"}/><span style={{color: blueColor}}>{selectedShipment.externalDeliveryNumber}</span> </div>
                    </Grid>
                    <Grid container sx={{width: "fit-content", color: greyishBlue500}}>
                        <div><FormattedMessage id={"wms.receptionList.returnModal.orderNumber"}/><span style={{color: blueColor}}>{selectedShipment.order.externalId}</span> </div>
                    </Grid>

                <CustomButton onClick={() => handleBeginValidation()} fullWidth><FormattedMessage id={"wms.ccReception.shipmentModal.manualChoiceButtonLabel"}/></CustomButton>
                <CustomButton onClick={() => handleClose()} fullWidth color={"default"}><FormattedMessage id={"wms.ccReception.shipmentModal.cancel"}/></CustomButton>
            </Grid>
        </Popup>
    );
}

export default ReturnShipmentModal;